"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickPreventionOnDoubleClick = void 0;
const react_1 = require("react");
const cancellable_promise_1 = require("./cancellable-promise");
const delay_1 = require("./delay");
const use_cancellable_promises_1 = require("./use-cancellable-promises");
const useClickPreventionOnDoubleClick = (onClick, onDoubleClick, doubleClickToFullscreen) => {
    const api = use_cancellable_promises_1.useCancellablePromises();
    const handleClick = react_1.useCallback(async () => {
        api.clearPendingPromises();
        const waitForClick = cancellable_promise_1.cancellablePromise(delay_1.delay(200));
        api.appendPendingPromise(waitForClick);
        try {
            await waitForClick.promise;
            api.removePendingPromise(waitForClick);
            onClick();
        }
        catch (errorInfo) {
            api.removePendingPromise(waitForClick);
            if (!errorInfo.isCanceled) {
                throw errorInfo.error;
            }
        }
    }, [api, onClick]);
    const handleDoubleClick = react_1.useCallback(() => {
        api.clearPendingPromises();
        onDoubleClick();
    }, [api, onDoubleClick]);
    const returnValue = react_1.useMemo(() => {
        if (!doubleClickToFullscreen) {
            return [onClick, onDoubleClick];
        }
        return [handleClick, handleDoubleClick];
    }, [
        doubleClickToFullscreen,
        handleClick,
        handleDoubleClick,
        onClick,
        onDoubleClick,
    ]);
    return returnValue;
};
exports.useClickPreventionOnDoubleClick = useClickPreventionOnDoubleClick;
//# sourceMappingURL=use-click-prevention-on-double-click.js.map